module.exports = {
  eventCategory: 'Editor UI | Tool Menu | customize | background',

  render: function () {
    this.category && this.trackEvent({
      eventAction: 'show',
      eventLabel: this.category.id
    });
  }
};
